import { reasonParams } from "../detail/reasonsConditions";

export function checkReasonChange(value) {
  let sections = [];
  switch (value) {
  case "FE2":
  case "FA2":
    sections.push("vatCompetence");
    break;
  case "FE6":
  case "FA6":
    sections.push("asset");
    break;
  case "FE10":
  case "FE11":
  case "FA8":
  case "FA9":
    sections.push("withholding");
    break;
  case "FE12":
  case "FE13":
  case "FA10":
  case "FA11":
    sections.push("vatCollectability");
    break;
  case "FE14":
  case "FE15":
  case "FA12":
  case "FA13":
    sections.push("intrastat");
    break;
  default:
    sections.push("vatCompetence");
    break;
  }
  return sections;
}

const calcExemptionNatureId = (article, rates) => {
  let retVal;
  if (article.vatRate === "0.0" && !article.exemptionNatureId && article.exemptionNature) {
    rates.map((it) => {
      if (it.nature === article.exemptionNature && !retVal) {
        retVal = it.id;
      }
      return null;
    });
  }
  return retVal;
};

export function mergeAccountingLines(accountingLines, rates) {
  let newLines = [];
  accountingLines.map((line) => {
    let itemIndex = newLines.map((item) => item.accountCode).indexOf(line.accountCode);
    let isSameEndDate = true;
    let isSameStartDate = true;
    if (newLines[itemIndex]?.articles) {
      newLines[itemIndex].articles.map((el) => {
        isSameEndDate = el.endPeriodDate ? el.endPeriodDate === line.endPeriodDate : isSameEndDate;
        isSameStartDate = el.endPeriodDate ? el.startPeriodDate === line.startPeriodDate : isSameStartDate;
        return el;
      });
    }
    if (itemIndex === -1 || !isSameEndDate || !isSameStartDate) {
      if (line.articleCode || line.articleDesc) {
        newLines.push({
          ...line,
          articles: [
            {
              articleCode: line.articleCode,
              articleDesc: line.articleDesc,
              debit: line.debit,
              credit: line.credit,
              regimeId: line.regimeId,
              regimeExtraField: line.regimeExtraField,
              vatRate: line.vatRate,
              articleUuid: line.uuid,
              vatDestinationId: line.vatDestinationId,
              endPeriodDate: line.endPeriodDate,
              startPeriodDate: line.startPeriodDate,
              exemptionNatureId: line.exemptionNatureId || calcExemptionNatureId(line, rates)
            }
          ]
        });
      } else {
        newLines.push(line);
      }
    } else {
      if (line.articleCode || line.articleDesc) {
        newLines[itemIndex].credit = newLines[itemIndex].credit + line.credit;
        newLines[itemIndex].debit = newLines[itemIndex].debit + line.debit;
        let articles = newLines[itemIndex].articles ? newLines[itemIndex].articles : [];
        newLines[itemIndex].articles = [
          ...articles,
          {
            articleCode: line.articleCode,
            articleDesc: line.articleDesc,
            debit: line.debit,
            credit: line.credit,
            regimeId: line.regimeId,
            regimeExtraField: line.regimeExtraField,
            vatRate: line.vatRate,
            articleUuid: line.uuid,
            vatDestinationId: line.vatDestinationId,
            endPeriodDate: line.endPeriodDate,
            startPeriodDate: line.startPeriodDate,
            exemptionNatureId: line.exemptionNatureId || calcExemptionNatureId(line)
          }
        ];
      } else {
        newLines.push(line);
      }
    }
    return newLines;
  });
  return newLines;
}

export function changeAccountingLine(
  newId, currentItem, accountingLines
) {
  let modifiedLines = [];
  accountingLines.map((line) => {
    if (line.uuid === currentItem.currentLine) {
      let removeArticle = line.articles;
      let debitToRemove = 0;
      let creditToRemove = 0;
      debitToRemove = line.articles.find((item) => item.articleDesc === currentItem.currentArticle.articleDesc).debit;
      creditToRemove = line.articles.find((item) => item.articleDesc === currentItem.currentArticle.articleDesc).credit;
      let articleIndex = line.articles.map((item) => item.articleDesc).indexOf(currentItem.currentArticle.articleDesc);
      removeArticle.splice(articleIndex, 1);
      modifiedLines.push({
        ...line,
        articles: removeArticle,
        debit: line.debit - debitToRemove,
        credit: line.credit - creditToRemove
      });
    } else if (line.uuid === newId) {
      let addArticle = line.articles ? line.articles : [];
      addArticle.push(currentItem.currentArticle);
      modifiedLines.push({
        ...line,
        articles: addArticle,
        debit: line.debit + currentItem.currentArticle.debit,
        credit: line.credit + currentItem.currentArticle.credit
      });
    } else {
      modifiedLines.push({ ...line });
    }
    return modifiedLines;
  });
  return modifiedLines;
}

// al momento deprecata
export function unmergeAccountingLines(accountingLines) {
  let newLines = [];
  accountingLines.map((line) => {
    if (line.articles?.length > 0) {
      line.articles.map((el) => {
        let currentLine = {
          accountCode: line.accountCode,
          accountDesc: line.accountDesc,
          accountType: line.accountType,
          articleDesc: el.articleDesc,
          articleCode: el.articleCode,
          credit: el.credit,
          debit: el.debit,
          endPeriodDate: line.endPeriodDate,
          startPeriodDate: line.startPeriodDate,
          currency: line.currency,
          vatRate: el.vatRate,
          regimeId: el.regimeId,
          regimeExtraField: el.regimeExtraField,
          vatDestinationId: el.vatDestinationId,
          exemptionNatureId: el.exemptionNatureId,
          exemptionNature: el.exemptionNature,
          nonDeductibleVATRate: line.nonDeductibleVATRate,
          uuid: el.articleUuid
        };
        newLines.push(currentLine);
        return newLines;
      });
    } else {
      let currentLine = {
        accountCode: line.accountCode,
        accountDesc: line.accountDesc,
        accountType: line.accountType,
        articleDesc: line.articleDesc,
        articleCode: line.articleCode,
        credit: line.credit,
        debit: line.debit,
        endPeriodDate: line.endPeriodDate,
        startPeriodDate: line.startPeriodDate,
        currency: line.currency,
        vatRate: line.vatRate,
        regimeId: line.regimeId,
        regimeExtraFilined: line.regimeExtraField,
        vatDestinationId: line.vatDestinationId,
        exemptionNatureId: line.exemptionNatureId,
        exemptionNature: line.exemptionNature,
        nonDeductibleVATRate: line.nonDeductibleVATRate,
        uuid: line.uuid
      };
      newLines.push(currentLine);
    }
    return newLines;
  });
  return newLines;
}

export function checkErrors(detail) {
  if (detail.registrationDate && detail.reasonId && detail.accountingLines) {
    return null;
  } 
  let errors = {
    registrationDate: !detail.registrationDate || detail.registrationDate === "",
    reasonId: !detail.reasonId || detail.reasonId === "",
    accountingLines: !detail.accountingLines || detail.accountingLines.length === 0
  };
  return errors;
  
}

export function getReasonParams(reasonCode) {
  let currentParams = {};
  reasonParams.map((item) => {
    if (item.reasonCode === reasonCode.toString()) {
      currentParams = item;
    }
    return currentParams;
  });
  return currentParams;
}
